import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./otherSilk.png"

const シルク追加10個以上 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { otherSilk: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={`シルク追加10個以上\n（部品番号・ピン番\n除く）`}
      src={img}
      helpURL={HELP_LINKS["シルク追加10個以上（部品番号・ピン番除く）"]}
    >
      <RadioGroup name={estimateField.otherSilk.key} selectedValue={values.otherSilk} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["シルク追加10個以上（部品番号・ピン番除く）"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["シルク追加10個以上（部品番号・ピン番除く）"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.otherSilk} />
    </OneClickField>
  )
}

export default シルク追加10個以上
